import React from "react";
import {
  Layout,
  BPLogo,
  Container,
  PageHeaderText,
} from "./Layout";

const RangerLayout = ({ children, title }) => {
  return (
    <Layout>
      <BPLogo src="/static/images/logo-banner.png" />
      <Container>
        {title && (
          <PageHeaderText>{title}</PageHeaderText>
        )}
        {children}
      </Container>
    </Layout>
  );
};

export default RangerLayout;
